__turbopack_context__.v({
  "grid": "style-module-scss-module__ZT0sya__grid",
});
